<template>
<div class="regionalManagement">
  <el-drawer :title="drawerTitle" :size="drawerWidth" :modal="false" :visible.sync="drawerShow" @close="closeMess" :wrapperClosable="false" direction="rtl" ref="drawer">
    <regional-drawer v-if="drawerShow" :editData="selectData" :handleType="handleType" :loading.sync="loading" @confirm="handleConfirm" @cancel="handleCancel"></regional-drawer>
  </el-drawer>
  <div class="mainContent" :style="styleObject">
    <div class="query">
      <span v-if="isPermit('zone:query')">
         <el-select v-model="zonetype" placeholder="区域类别" @change="$forceUpdate()" clearable>
            <el-option v-for="item in typeoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
         </el-select>
         <el-select v-model="person" placeholder="负责人员" @change="$forceUpdate()" clearable>
            <el-option v-for="item in personoptions" :key="item.id" :label="item.username" :value="item.id"></el-option>
         </el-select>
         <el-input v-model.trim="names" autocomplete="off" placeholder="区域名称" @keyup.enter.native="serachData"></el-input>
         <button class="primaryBtn" @click="serachData()">搜索</button>
      </span>
      <button class="primaryBtn" @click="addClick('区域')" v-if="isPermit('zone:add')">新增</button>
    </div>
    <border-table :tableData="dataList" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading" :current-page="pagination.page" @currentChange="zoneCurrentChange" @sizeChange="zoneSizeChange">
      <el-table-column prop="name" label="区域名称" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="zonetypename" label="区域类别"></el-table-column>
      <el-table-column prop="buildingStructure" label="建筑结构"></el-table-column>
      <el-table-column prop="danger" label="火灾危险性"></el-table-column>
      <el-table-column prop="fireRating" label="耐火等级"></el-table-column>
      <el-table-column prop="personname" label="负责人员"></el-table-column>
      <el-table-column prop="image" label="区域底图">
        <template slot-scope="scope" v-if="scope.row.image">
          <img :src="scope.row.image" style="cursor:pointer" width="25" height="25" @click="imgMask(scope.row.image)" />
        </template>
      </el-table-column>
      <el-table-column prop="" label="操作" v-if="isPermit('zone:edit')||isPermit('zone:del')">
        <template slot-scope="scope">
          <el-button @click="editClick(scope.row)" size="small" class="edit" v-if="isPermit('zone:edit')">编辑</el-button>
          <el-button @click="delClick(scope.row)" size="small" class="del" v-if="isPermit('zone:del')">删除</el-button>
        </template>
      </el-table-column>
    </border-table>
  </div>
  <div class="imgMasking" v-if="showImg">
    <div class="closeBtn" @click="showImg = false"><i class="el-icon-circle-close" /></div>
    <div class="imgMask">
      <img :src="imgUrl" alt="">
    </div>
  </div>
</div>
</template>

<script>
import BorderTable from "@/components/common/BorderTable";
import RegionalDrawer from "@/components/regionalManagement/RegionalDrawer";
export default {
  components: {
    BorderTable,
    RegionalDrawer
  },
  data() {
    return {
      showImg: false,
      imgUrl: '',
      loading: false,
      drawerShow: false,
      typeoptions: [],
      personoptions: [],
      selectedName: "",
      radio: "1",
      styleObject: {
        height: ""
      },
      tableLoading: false,
      dataList: [],
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      drawerTitle: "",
      drawerWidth: "500px",
      zonetype: '',
      person: null,
      names: null,
      selectData: {}
    };
  },
  created() {
    this.makeheight();

    this.request.get("/Dictionary/query?type=zone_type").then(res => {
      // console.log(res);
      if (res.code == 200) {
        this.typeoptions = res.data;
      } else if(res.code==500){
        this.typeoptions = []
        // this.msg.warn('未查询到区域类别');
      }
    }).catch(error => {
      console.log(error)
    });
    this.getPerson()
    this.type = -1;
    this.reloaTable();

  },
  methods: {
     //回调负责人
     getPerson(){
        this.request.get("/Zone/findperseonbyorgid").then(res => {
            // console.log(res);
            if (res.code == 200) {
            this.personoptions = res.data;
            } else if(res.code==500){
            this.personoptions = [];
            // this.msg.warn('未查询到负责人列表');
            }
         }).catch(error => {
            console.log(error)
         });
     },
     serachData() {
      //查询//搜索
      this.pagination.currentPage = 1;
      this.reloaTable();
    },
    reloaTable() {
      this.tableLoading = true
      if (this.zonetype) {
        this.type = this.zonetype;
      } else {
        this.type=-1;
      }
      if (!this.names) {
        this.names = null;
      } else {
        this.names = this.names.replace(/(^\s*)|(\s*$)/g, "");         
      }
      let params = {
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        type: this.type,
        person: this.person,
        name: this.names
      };
      this.request.post("/Zone/query", params).then(res => {
        console.log(res);
        this.tableLoading = false
        if (res.code == 200) {
          this.dataList = res.data;
          this.pagination.total = res.total;
        } else if(res.code==500){
          this.dataList = [];
          this.pagination.total = 0;
          this.msg.warn(res.msg);
        }
      }).catch(error => {
        console.log(error)
      })
    },
    //表格当前页变化时
    zoneCurrentChange(val) {
      this.pagination.currentPage = val;
      this.reloaTable();
    },
    //表格展示条数变化时
    zoneSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.reloaTable();
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    editClick(row) {
      //编辑
      this.selectData = row
      this.drawerShow = true;
      this.drawerTitle = "编辑区域";
      this.handleType = "edit";
    },
    delClick(row) {
      //删除
      this.$confirm('此操作将永久删除该区域, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.get('/Zone/delete/' + row.id).then(data => {
          if (data.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            let num = ''
            if (this.pagination.total > 1) {
               num = (this.pagination.total - 1) % this.pagination.pageSize
               if (num == 0) {
               this.pagination.currentPage = this.pagination.currentPage - 1
               }
            }
            this.reloaTable();
          } else {
            this.$message({
              type: 'error',
              message: '删除失败!' + data.msg
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addClick(type) {
      //新增
      this.drawerShow = true;
      this.drawerTitle = "新增" + type;
      this.handleType = 'add'
    },
    //关闭抽屉
    closeMess() {
      this.loading = false;
    },
    handleConfirm(data) { //确认
      console.log(data)
      if (data == 200) {
        this.drawerShow = false
        this.reloaTable()
        this.getPerson()
      }
    },
    handleCancel(data) { //取消
      console.log(data)
      this.drawerShow = false
    },
    //图片放大
    imgMask(data) {
      this.imgUrl = data
      this.showImg = true
    },
  }
};
</script>

<style lang="scss" scoped>
.regionalManagement {
  .topTabs {
    height: 40px;
    background: #fff;
  }

  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    // .radio{
    //    margin: 20px 0;
    // }
    .query {
      margin-bottom: 20px;
    }

    .edit {
      background: #327ae6;
      color: #fff;
    }

    .del {
      background: #eaa13a;
      color: #fff;
    }

    // .btnS{
    //    color: #2A7EE1;
    //    border:1px solid #A1C6F3;
    //    background: #EFF3FC;
    //    margin-right:24px;
    //    &:hover{

    //    }
    // }
  }

  .imgMasking {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 9999;
    .closeBtn {
      position: absolute;
      top: 50px;
      right: 100px;
      font-size: 50px;
      color: #fff;
      cursor: pointer;
    }

    .imgMask {
      height: 600px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      background: #fff;
      img {
        height: 100%;
      }
    }
  }
}
</style><style lang="scss">
.regionalManagement {
  .mainContent {
    .query {
      .el-input {
        width: 380px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }

      .el-select {
        width: 170px;
        margin-right: 10px;

        .el-input {
          width: 170px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 36px;
            height: 36px;
          }
        }
      }

      .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
        border-color: #42bced;
        background: #42bced;
      }

      .el-radio.is-checked .el-radio__label {
        color: #147dd9 !important;
      }
    }
  }

  .imgMasking {

    [class*=" el-icon-"],
    [class^=el-icon-] {
      font-size: 50px;
      cursor: pointer;
    }
  }
}
</style>
